// Bits every test config shares.

/** "Your answers go to the UIC guidance office": the school by name, never "your school". */
export const guidanceOfficeFact = (lang, school) => ({
  icon: 'users',
  text: school
    ? lang === 'fil'
      ? `Makikita ng ${school} guidance office ang iyong mga sagot`
      : `Your answers go to the ${school} guidance office`
    : lang === 'fil'
      ? 'Makikita ng guidance office ang iyong mga sagot'
      : 'Your answers go to the guidance office',
});

/** One line from a list, in turn, so the same reply doesn't repeat back to back. */
export const inTurn = (lines, lang, n) => {
  const list = lang === 'fil' && lines.fil ? lines.fil : lines.en;
  return list[n % list.length];
};

// Anna's in-between lines for the well-being tests (rewritten 2026-10-20 so they read like a chat,
// not a form: no "noted", and the everyday ones hand off to the next question). They acknowledge,
// never praise or judge an answer, so they don't nudge the next one.
export const NOTED = {
  en: ["Thanks. Here's the next one.", "Okay, let's keep going.", 'Got it. On to the next one.', "Alright, here's another.", 'Thanks for that. Next one:'],
  fil: ['Salamat. Ito ang susunod.', 'Sige, tuloy lang tayo.', 'Okay. Sa susunod na tanong na tayo.', 'Ayos, eto pa isa.', 'Salamat diyan. Susunod:'],
};
// After a hard answer: like a person who heard it, never alarmed (the crisis card comes at the end)
export const HEAVY = {
  en: ['That sounds hard. Thank you for telling me.', "I'm sorry it's been like that. Thanks for being honest.", "That's a lot. Take a breath, then we'll do the next one.", 'Thank you for trusting me with that.'],
  fil: ["Mukhang mahirap 'yan. Salamat sa pagsabi sa akin.", 'Nakakalungkot na ganyan ang pinagdadaanan mo. Salamat sa pagiging tapat.', "Mabigat 'yan. Huminga muna, tapos sa susunod na tanong tayo.", 'Salamat sa tiwala mo.'],
};
// When a good thing isn't true for them: no sense of a wrong answer, and no praise either
export const HONEST = {
  en: ["That's okay. Thanks for being real about it.", "Not everything fits, and that's fine. Thanks.", 'Thanks for answering honestly. It really helps.'],
  fil: ["Okay lang 'yan. Salamat sa pagiging totoo.", "Hindi lahat swak, at ayos lang 'yon. Salamat.", "Salamat sa tapat na sagot. Malaking tulong 'yan."],
};

export const pick = (text, lang) => {
  if (text == null) return '';
  if (typeof text === 'string') return text;
  return (lang === 'fil' ? text.fil : text.en) || text.en || '';
};
